import AppForm from './components/AppForm';
import AppFormItem from './components/AppFormItem';
import AppFloatButton from './components/AppFloatButton';
import AppModalDelete from './components/AppModalDelete';
import AppStatusTag from './components/AppStatusTag';
import AppRowActions from './components/AppRowActions';
import AppAutoComplete from './components/AppAutoComplete';
import AppColorPicker from './components/AppColorPicker';
import AppWidgetCount from './components/AppWidgetCount';
import AppTextLabel from './components/AppTextLabel';
import AppSkeletonTable from './components/AppSkeletonTable';
import AppSkeletonCardTable from './components/AppSkeletonCardTable';
import AppSkeletonCardForm from './components/AppSkeletonCardForm';
import AppButton from './components/AppButton';
import AppPrintButton from './components/AppPrintButton';
import AppTag from './components/AppTag';
import AppUploadButton from './components/AppUploadButton';
import AppGaleria from './components/AppGaleria';
import AppTabRoute from './components/AppTabRoute';
import AppSkeletonCardField from './components/AppSkeletonCardField';
import AppButtonExport from './components/AppButtonExport';
import AppPermissionAlert from './components/AppPermissionAlert';
import AppRouterLink from './components/AppRouterLink';

export default function (app) {
    app.component('AppForm', AppForm);
    app.component('AppFormItem', AppFormItem);
    app.component('AppFloatButton', AppFloatButton);
    app.component('AppModalDelete', AppModalDelete);
    app.component('AppStatusTag', AppStatusTag);
    app.component('AppRowActions', AppRowActions);
    app.component('AppAutoComplete', AppAutoComplete);
    app.component('AppColorPicker', AppColorPicker);
    app.component('AppWidgetCount', AppWidgetCount);
    app.component('AppTextLabel', AppTextLabel);
    app.component('AppSkeletonTable', AppSkeletonTable);
    app.component('AppSkeletonCardTable', AppSkeletonCardTable);
    app.component('AppSkeletonCardForm', AppSkeletonCardForm);
    app.component('AppButton', AppButton);
    app.component('AppPrintButton', AppPrintButton);
    app.component('AppTag', AppTag);
    app.component('AppUploadButton', AppUploadButton);
    app.component('AppGaleria', AppGaleria);
    app.component('AppTabRoute', AppTabRoute);
    app.component('AppSkeletonCardField', AppSkeletonCardField);
    app.component('AppButtonExport', AppButtonExport);
    app.component('AppPermissionAlert', AppPermissionAlert);
    app.component('AppRouterLink', AppRouterLink);
}
